import React from 'react';
import { UseEditableReturns } from '@cad-arc';
import { pickBy } from 'lodash';

type InputHandle = {
    /**
     * Sometimes the form control is in "view" mode which means
     * we won't have an input rendered. In this scenario,
     * `ref` and `setEditableMode` will both be undefined
     */
    ref: undefined | React.RefObject<HTMLInputElement>;
    setEditableMode: undefined | Omit<UseEditableReturns, 'containerProps'>['toggleMode'];
    /**
     * Additional information that tells us where in the react tree
     * the input is being rendered
     */
    scope: string;
};

export class InputHandlerManager<T extends string = string> {
    private handleMap: Partial<Record<T, InputHandle>> = {};
    getHandle(name: T): InputHandle | undefined {
        return this.handleMap[name];
    }
    registerHandle(name: T, inputHandle: InputHandle) {
        this.handleMap[name] = inputHandle;
    }
    unregisterHandle(name: T) {
        delete this.handleMap[name];
    }
    getHandlesForScope(scope: string) {
        return pickBy<InputHandle>(this.handleMap, (handle) => {
            return handle.scope === scope;
        }) as typeof this.handleMap;
    }
}
